<a id="csv-donwload"></a>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <div class="grid">
    <div class="col-12">
      <label for="ms-groupedArea">都道府県での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedArea"
          [group]="true"
          [(ngModel)]="selectedArea"
          (onChange)="doChangeArea($event)"
          placeholder="表示したい都道府県を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearArea()"
          pTooltip="選択解除"
          [disabled]="selectedArea.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedStores">店舗での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedStores"
          [group]="true"
          [(ngModel)]="selectedStores"
          (onChange)="doChangeStores($event)"
          placeholder="表示したい店舗を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearStores()"
          pTooltip="選択解除"
          [disabled]="selectedStores.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedStores">登録日時での絞り込み</label>
      <div class="card justify-content-center p-label">
        <p-select
          [options]="registrationDateOptions"
          [(ngModel)]="filterRegistrationDate"
          (onChange)="doChangeRegistrationDate($event)"
          optionLabel="name"
          placeholder="登録日時" />
      </div>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="showPurchased"
            inputId="showPurchased"
            [binary]="true"
            (onChange)="reloadStocks($event)"></p-checkbox>
          <label for="showPurchased">購入完了商品を表示する</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="showDisplay"
            inputId="showDisplay"
            [binary]="true"
            (onChange)="reloadStocks($event)"></p-checkbox>
          <label for="showDisplay">展示商品を表示する</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="showFound"
            inputId="showFound"
            [binary]="true"
            (onChange)="reloadStocks($event)"></p-checkbox>
          <label for="showFound">店頭無・店員無の店舗を非表示にする</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="filterOneStock"
            inputId="filterOneStock"
            [binary]="true"
            (onChange)="reloadStocks($event)"></p-checkbox>
          <label for="filterOneStock">在庫数:1の店舗を非表示にする</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="hideNegativeProfit"
            inputId="hideNegativeProfit"
            [binary]="true"
            (onChange)="applyProductFilter()"></p-checkbox>
          <label for="hideNegativeProfit">利益率・利益額がマイナスの商品を非表示にする</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="onlyWithMember"
            inputId="onlyWithMember"
            [binary]="true"
            (onChange)="applyProductFilter()"></p-checkbox>
          <label for="onlyWithMember">みんなの仕入れ実績・LINE報告がある商品だけ表示する</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <p-iconfield class="full-height">
        <div class="flex align-items-center gap-1">
          <p-checkbox
            [(ngModel)]="onlyPopular"
            inputId="onlyPopular"
            [binary]="true"
            (onChange)="applyProductFilter()"></p-checkbox>
          <label for="onlyPopular">先月販売数が50以上の商品だけ表示する</label>
        </div>
      </p-iconfield>
    </div>
    <div class="col-12">
      <button
        pButton
        class="p-button-outlined"
        (click)="presetDialog.open()">
        <i
          class="pi pi-bookmark"
          aria-hidden="true"></i>
        お気に入り
      </button>
    </div>
  </div>
</p-panel>
<app-store-preset-dialog
  #presetDialog
  componentName="yamada"
  [currentSelection]="{ selectedArea: selectedArea, selectedStores: selectedStores }"
  (presetLoaded)="onPresetLoaded($event)"></app-store-preset-dialog>

<br />
<br />

<div class="table-header-sticky-outer">
  全{{ products.length.toLocaleString() }}件
  <p-table
    #table
    showGridlines
    [value]="products"
    columnResize="expand"
    [tableStyle]="{ 'min-width': '50rem' }"
    class="table-header-sticky"
    sort="multiple"
    [paginator]="true"
    [rows]="30"
    [globalFilterFields]="['jan', 'asin', 'name']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-3">
            <div class="p-d-flex">
              @if (!isTestAccount) {
                <button
                  type="button"
                  pButton
                  iconOnly
                  pRipple
                  (click)="downloadCsv(table)"
                  class="p-mr-2"
                  pTooltip="CSV"
                  tooltipPosition="bottom">
                  <i
                    class="pi pi-download"
                    aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
          <div class="col-5">
            <label
              for="sort-select"
              class="mr-2">
              並び替え
            </label>
            <p-select
              inputId="sort-select"
              [options]="sortOptions"
              [(ngModel)]="selectedSort"
              optionLabel="label"
              optionValue="value"
              placeholder="並び替え"
              (onChange)="applySort()"></p-select>
          </div>
          <div class="col-3">
            <span class="p-input-icon-left ml-auto input-full">
              <input
                pInputText
                class="input-full"
                type="text"
                [(ngModel)]="keyword"
                (input)="table.filterGlobal($any($event.target).value, 'contains')"
                placeholder="検索キーワード" />
            </span>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="table.clear(); keyword = ''">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th width="5%">画像</th>
        <th width="8%">Keepaグラフ</th>
        <th width="12%">JAN / ASIN</th>
        <th width="7%">
          Amazon価格
          <br />
          POS（仕入値）
        </th>
        <th
          width="6%"
          pTooltip="FBAで売った場合。利益額 = Amazon価格 − 販売手数料 − FBA配送手数料 − 仕入値、利益率 = 利益額 ÷ Amazon価格"
          tooltipPosition="top">
          利益額
          <br />
          利益率
        </th>
        <th width="14%">商品名</th>
        <th
          width="48%"
          style="min-width: 22rem">
          在庫状況
        </th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-product>
      <!--<tr class="{{ getRowStyle(product) }}"> -->
      <tr>
        <td>
          <a
            [href]="'https://www.amazon.co.jp/dp/' + product.asin"
            target="_blank">
            <img
              [src]="product.imageUrl"
              style="width: 50px" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="product.asin"></app-keepa-graph>
        </td>
        <td>
          {{ product?.jan }}
          <br />
          {{ product?.asin }}
          <br />
          登録日: {{ product?.registrationDate | date: 'yyyy/MM/dd' }}
          <br />
          総在庫数: {{ product?.totalStocks }}
          @if (product?.boughtPastMonth != null) {
            <br />
            先月販売数: {{ product.boughtPastMonth < 10 ? '9以下' : product.boughtPastMonth }}
          }
        </td>
        <td>
          @switch (product.amazonPriceSource) {
            @case ('current') {
              <span>Amazon: {{ product.amazonPrice | number }}</span>
            }
            @case ('last') {
              <span>
                Amazon: 出品者なし（最終 {{ product.amazonPrice | number }}円 {{ product.lastKnownPriceAt }}）
              </span>
            }
            @case ('stale') {
              <span>Amazon: -（1年より古い値しか無いので出しません）</span>
            }
            @default {
              <span>Amazon: 出品者なし</span>
            }
          }
          <br />
          POS: {{ product.price | number }}
        </td>
        <td [style.color]="product.profitPrice == null ? null : product.profitPrice < 0 ? 'red' : 'blue'">
          @if (product.profitPrice != null) {
            {{ product.profitPrice | number }}
            <br />
            {{ product.profitRate | percent: '1.1-1' }}
            @if (product.amazonPriceSource === 'last') {
              <br />
              <small>参考</small>
            }
          } @else {
            -
          }
        </td>
        <td>
          <a
            [href]="'https://www.amazon.co.jp/dp/' + product.asin"
            target="_blank">
            {{ product?.name }}
          </a>
          @for (m of product.memberPurchases; track m) {
            <div class="text-600 text-sm mt-1">
              実績 {{ m.userName }} {{ m.buyingDate }} 仕入 {{ m.buyingPrice | number }} → 出品
              {{ m.sellingPrice | number }}（{{ m.profitPrice >= 0 ? '+' : '' }}{{ m.profitPrice | number }}）
            </div>
          }
          @for (r of product.memberReports; track r) {
            <div class="text-600 text-sm mt-1">
              {{ r.line }}
            </div>
          }
        </td>
        <td>
          <app-spreadsheet-stock-badge
            [stocks]="product.filteredStocks"
            [showPurchased]="showPurchased"
            [showDisplay]="showDisplay"></app-spreadsheet-stock-badge>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- 商品共有の実績のうち、在庫一覧のどの商品にも付かなかったもの（改廃リストに無い商品） -->
@if (otherPurchases.length > 0) {
  <div class="mt-3">
    <p-panel
      header="みんなの仕入れ実績（直近30日・在庫リストに無い商品 {{ otherPurchases.length }}件）"
      [toggleable]="true"
      [collapsed]="true">
      <app-member-row-table
        [rows]="otherPurchaseRows"
        csvName="仕入れ実績"
        [keyword]="keyword"></app-member-row-table>
    </p-panel>
  </div>
}

<!-- みんなの報告（LINE）のうち在庫一覧のどの商品にも付かなかったものと、改廃リストの利益商品で在庫照合がまだのもの。
上の一覧は在庫を引いた商品だけにして、この 2 つは下にまとめて出す（2026-10-20 ユーザー指定） -->
@if (bottomRows.length > 0) {
  <div class="mt-3">
    <p-panel
      header="みんなのLINE報告・改廃リストの利益商品（直近30日・在庫リストに無い商品 {{ bottomRows.length }}件）"
      [toggleable]="true"
      [collapsed]="true">
      <app-member-row-table
        [rows]="bottomRows"
        csvName="LINE報告_改廃"
        (reportDeleted)="onReportDeleted($event)"
        [keyword]="keyword"></app-member-row-table>
    </p-panel>
  </div>
}
